import { BASEURL, MEMBER } from "./constant";

const routes = {
  signIn: (pathname) =>
    MEMBER + "/signin?r=" + window.location.origin + pathname + "&withToken=1",
};

export default routes;
